import axios from 'axios';

// Get the API base URL from environment variables for flexibility
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://installmentzone.com/api/admin_panel/v1';

// Create an Axios instance with default configuration
const apiClient = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
    },
    timeout: 15000, // Set a timeout for requests (15 seconds)
});

// Request Interceptor: Add the Authorization token to every request
apiClient.interceptors.request.use(
    (config) => {
        // Retrieve token from localStorage or another storage
        const token = localStorage.getItem('admin_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        console.error("Request Interceptor Error:", error.message);
        return Promise.reject(error);
    }
);

// Response Interceptor: Handle responses and global errors
apiClient.interceptors.response.use(
    (response) => response, // Pass through successful responses
    (error) => {
        // Check if error response exists
        if (error.response) {
            const { status } = error.response;
            const errorMessage = error.response.data?.message || "An error occurred.";

            switch (status) {
                case 401:
                    console.warn("Unauthorized (401): Token invalid or expired.");
                    localStorage.removeItem('admin_token'); // Clear invalid token
                    if (window.location.pathname !== '/login') {
                        alert("Session expired. Please log in again.");
                        window.location.href = '/login'; // Redirect to login page
                    }
                    break;

                case 403:
                    console.error("Forbidden (403): Access denied.");
                    alert("You do not have permission to perform this action.");
                    break;

                case 500:
                    console.error("Server Error (500):", errorMessage);
                    alert("A server error occurred. Please try again later.");
                    break;

                default:
                    console.error(`Error ${status}: ${errorMessage}`);
                    alert(errorMessage);
            }
        } else if (error.request) {
            // Network error
            console.error("Network Error:", error.message);
            alert("A network error occurred. Please check your internet connection.");
        } else {
            // Other errors
            console.error("Error:", error.message);
            alert("An unexpected error occurred. Please try again.");
        }

        return Promise.reject(error); // Propagate the error to the caller
    }
);

export default apiClient;
